import { FlexibleDataTable } from "./FlexibleDataTable";
import React from "react";
import createReactClass from "create-react-class";
import PropTypes from "prop-types";
import ElstrLangStore from "elstr-jslib/src/scripts/stores/ElstrLangStore";
import DetailsActions from "../../actions/DetailsActions";
import DetailsStore from "../../stores/DetailsStore";
import ElstrLoadingStates from "elstr-jslib/src/scripts/constants/ElstrLoadingStates";
import DetailPisysTableMessage from "./DetailPisysTableMessage";

const DetailPisysProdWF = createReactClass({
  propTypes: {
    material: PropTypes.object.isRequired,
  },

  getProdWF: function (material) {
    if (material.sMatHdrMatnr) {
      DetailsActions.getProdWF({
        materialNumber: material.sMatHdrMatnr,
        zvgb: material.sMatAtvMatnrZvgb,
        techNo: material.sMatHdrZeinr,
      });
    }
  },

  componentDidMount: function () {
    this.getProdWF(this.props.material);
  },

  componentDidUpdate: function (prevProps) {
    const prevMatnr = prevProps.material.sMatHdrMatnr;
    const currMatnr = this.props.material.sMatHdrMatnr;
    if (currMatnr && String(currMatnr) !== String(prevMatnr)) {
      this.getProdWF(this.props.material);
    }
  },

  render: function () {
    let materialData = DetailsStore.getProdWF();

    // show the user the loading state of the app
    let loadingState = DetailsStore.getLoadingStateFlexibleTable();
    let error = DetailsStore.getError();

    if (error == null && (materialData == null || materialData.dataDefintions == null || materialData.data == null)) {
      error = ElstrLangStore.text("DETAIL_TEXT_NODATA");
    }

    // case the request data is empty the arrow also should be displayed
    if (materialData.data !== undefined) {
      if (materialData.data.length <= 0) {
        error = ElstrLangStore.text("DETAIL_TEXT_NODATA");
      }
    }

    // return text loading when the loading state is EMPTY
    if (loadingState === ElstrLoadingStates.EMPTY) {
      return <DetailPisysTableMessage isLoading />;
    } else if (error !== null) {
      return <DetailPisysTableMessage>{error}</DetailPisysTableMessage>;
    } else {
      return <FlexibleDataTable dataDefintions={materialData.dataDefintions} data={materialData.data} />;
    }
  },
});

export default DetailPisysProdWF;
